import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="team-member-lookup" on the Add-person form.
// Picking a match from the lookup frame fills in the person's fields; the
// other matches drop away and the picked one stays as the confirmation.
export default class extends Controller {
  static targets = ["email", "firstName", "lastName"];

  declare readonly emailTarget: HTMLInputElement;
  declare readonly firstNameTarget: HTMLInputElement;
  declare readonly lastNameTarget: HTMLInputElement;

  pick(event: Event) {
    const picked = event.currentTarget as HTMLElement;
    const { email = "", firstName = "", lastName = "" } = picked.dataset;

    this.emailTarget.value = email;
    this.firstNameTarget.value = firstName;
    this.lastNameTarget.value = lastName;

    // The class, not the attribute: a `flex` utility on the row outranks [hidden].
    this.element.querySelectorAll<HTMLElement>("[data-match]").forEach((match) => {
      match.classList.toggle("hidden", match !== picked);
      match.toggleAttribute("data-picked", match === picked);
    });
  }
}
